"use client";

import React, { useEffect, useState, useCallback } from "react";
import { Button } from "../ui/button";
import { LinkAuthenticationElement, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
const CheckoutForm = ({
  userInfo
}) => {
  //  console.log(userInfo);
  const stripe = useStripe();
  const elements = useElements();
  const [email, setEmail] = useState(userInfo?.email || "");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => {
    if (!stripe) return;
    const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");
    if (!clientSecret) return;
    stripe.retrievePaymentIntent(clientSecret).then(({
      paymentIntent
    }) => {
      switch (paymentIntent?.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing...");
          break;
        case "requires_payment_method":
          setMessage("Payment failed. Please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);
  useEffect(() => {
    setEmail(userInfo?.email || "");
  }, [userInfo]);
  const handleSubmit = useCallback(async event => {
    event.preventDefault();
    if (!stripe || !elements) {
      setMessage("Stripe is not yet initialized.");
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    let returnUrl = `${window.location.origin}/`;
    if (typeof window !== "undefined") {
      const cId = sessionStorage.getItem("cId") || userInfo?.cId;
      const productId = sessionStorage.getItem("ProductId") || userInfo?.ProductId;
      const orderId = sessionStorage.getItem("order_id") || userInfo?.order_id;
      returnUrl += `${cId}/success/${productId}/${orderId}`;
    }
    //  console.log(returnUrl);
    const {
      error
    } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl
      }
    });
    if (error) {
      setMessage(error.message);
      setIsLoading(false);
    } else {
      setMessage("Payment successful!");
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [stripe, elements]);
  return <form id="payment-form" onSubmit={handleSubmit} className="space-y-4">
      <LinkAuthenticationElement id="link-authentication-element" options={{
      defaultValues: {
        email
      }
    }} className="text-primary/75 text-sm" onChange={event => setEmail(event.value?.email || "")} />
      <PaymentElement id="payment-element" className="mt-y" options={{
      layout: "tabs"
    }} />
      <Button disabled={isLoading || !stripe || !elements} id="submit" className="bg-blue-600 text-white font-semibold py-2 px-4 hover:bg-blue-700 transition disabled:opacity-50 rounded">
        {isLoading ? "Processing..." : "Pay now"}
      </Button>
      {message && <div className={`text-sm font-medium mt-2 ${message.includes("success") ? "text-green-500" : "text-red-500"}`}>
          {message}
        </div>}
    </form>;
};
export default CheckoutForm;